export const quotes = [
  {
    id: 'atomic-habits-systems',
    text: 'You do not rise to the level of your goals. You fall to the level of your systems.',
    author: 'James Clear',
    source: 'Atomic Habits',
    category: 'productivity',
    favorite: true,
  },
  {
    id: 'deep-work-focus',
    text: 'Who you are, what you think, feel, and do, what you love—is the sum of what you focus on.',
    // Gallagher's line from Rapt, which Newport quotes in Deep Work.
    author: 'Winifred Gallagher',
    source: 'Rapt, quoted in Deep Work',
    category: 'productivity',
    favorite: true,
  },
  {
    id: 'pragmatic-good-enough',
    text: 'Great software today is often preferable to perfect software tomorrow.',
    author: 'David Thomas & Andrew Hunt',
    source: 'The Pragmatic Programmer',
    category: 'technical',
    favorite: false,
  },
  {
    id: 'kahneman-confidence',
    text: 'The confidence people have in their beliefs is not a measure of the quality of evidence but of the coherence of the story the mind has managed to construct.',
    author: 'Daniel Kahneman',
    source: 'Thinking, Fast and Slow',
    category: 'psychology',
    favorite: true,
  },
  {
    id: 'burkeman-time',
    text: 'The problem with trying to make time for everything that feels important is that you definitely never will.',
    author: 'Oliver Burkeman',
    source: 'Four Thousand Weeks',
    category: 'productivity',
    favorite: false,
  },
  {
    id: 'housel-wealth',
    text: 'Spending money to show people how much money you have is the fastest way to have less money.',
    author: 'Morgan Housel',
    source: 'The Psychology of Money',
    category: 'finance',
    favorite: true,
  },
  {
    id: 'clean-code-naming',
    text: 'The proper use of comments is to compensate for our failure to express ourselves in code.',
    author: 'Robert C. Martin',
    source: 'Clean Code',
    category: 'technical',
    favorite: false,
  },
  {
    id: 'kleppmann-complexity',
    text: 'The major difference between a thing that might go wrong and a thing that cannot possibly go wrong is that when a thing that cannot possibly go wrong goes wrong it usually turns out to be impossible to get at or repair.',
    author: 'Douglas Adams',
    source: 'Quoted in Designing Data-Intensive Applications',
    category: 'technical',
    favorite: true,
  },
  {
    id: 'tree-proverb',
    text: 'The best time to plant a tree was 20 years ago. The second best time is now.',
    author: 'Chinese Proverb',
    source: null,
    category: 'wisdom',
    favorite: true,
  },
  {
    id: 'ship-harbor',
    text: 'A ship in harbor is safe, but that is not what ships are built for.',
    author: 'John A. Shedd',
    source: null,
    category: 'wisdom',
    favorite: false,
  },
  {
    id: 'seneca-busy',
    text: 'It is not that we have a short time to live, but that we waste a lot of it.',
    author: 'Seneca',
    source: 'On the Shortness of Life',
    category: 'wisdom',
    favorite: true,
  },
  {
    id: 'einstein-simple',
    text: 'Everything should be made as simple as possible, but not simpler.',
    author: 'Albert Einstein',
    source: null,
    category: 'wisdom',
    favorite: false,
  },
];
